
import Vue from 'vue';
import Component from 'vue-class-component';

// Components
import { VAppLayout, VAppMain } from '@/components/VApp';
import ErrorViewer from './components/ErrorViewer.vue';
import { VGridCol, VGridRow, VGridPageColumn } from 'vui';

@Component({
    components: {
        VGridCol,
        VGridRow,
        ErrorViewer,
        VGridPageColumn,
        VAppMain,
        VAppLayout,
    },
})
export default class Error404Page extends Vue {}
